import React, { Component } from 'react';
import { connect } from "react-redux";
import { Column, Row } from "@sm/helpers/simple-flexbox";
import { Panel, Well } from "react-bootstrap";
import { NavLink } from 'react-router-dom';
import Pagination from '@mui/material/Pagination';

import CustomButton from "@sm/components/custom/Button";
import Form from "@sm/core/Form";
import Modal from '@sm/components/custom/Modal';
import Multiselect from "@sm/components/custom/customMultiselect";
import PromptModal from '@modules/generateReport/PromptModal';
import Select from "@sm/components/custom/Select";
import Spinner from '@sm/components/Spinner';
import Table from "@sm/components/custom/Table";

import '@assets/css/mids.css';
import MidsIcon from '@assets/images/mids.png';

import * as actions from "@sm/actions";
import { crudActions } from "@sm/services/crudActions";
import { FETCH_PERMISSIONS } from '@sm/actions/types';
const store =  require('@sm/reducers/index');

class Mids extends Component {
  state = {
    controls: new Form({
      companyId: "",
      clientId: "",
      providerId: "",
      currency: "",
      country: "",
      trafficTypes: ["FTD", "MIXED", "TRUSTED"],
      categories: [],
      midName: ""
    }, [{
      name: "companyId",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "clientId",
      type: "isString",
      rules: {
        required: false
      }
    }, {
      name: "providerId",
      type: "isNumber",
      rules: {
        required: false
      }
    }, {
      name: "currency",
      type: "isString",
      rules: {
        required: false
      }
    }, {
      name: "country",
      type: "isString",
      rules: {
        required: false
      }
    }, {
      name: "trafficTypes",
      type: "isArray",
      rules: {
        min: 1,
        required: true
      }
    }, {
      name: "categories",
      type: "isArray",
      rules: {
        required: false
      }
    }, {
      name: "midName",
      type: "isString",
      rules: {
        required: false
      }
    }]),
    
    companies: [],
    companiesClients: [],
    companiesMids: [],
    providers: [],
    currencies: [],
    countries: [],
    paymentMethods: [],
    payoutMethods: [],
    midCategories: [],

    trafficTypes: [{
      label: "FTD",
      value: "FTD"
    }, {
      label: "Mixed",
      value: "MIXED"
    }, {
      label: "Trusted",
      value: "TRUSTED"
    }],

    filterOn: false,
    mids: [],
    merchantOptions: [],

    midsLinks: [{
      name: "ADD MIDs",
      url: "/add-mid",
    }],

    showPromptModal: false,
    changeValueMessage: "",
    editableField: "",
    editableMidId: "",
    editableFieldValue: "",
    originalEditableFieldValue: "",

    showModal: false,
    modalData: "",

    access: [],
    isLoading: true,
    isLoadingTable: false,
    isBurgerOpen: false,
    cloningMidId: null,
    currentPage: 1,
    pageSize: 100,
    count: 0,
    defaultSortBy: "merchants",
    isDescendingOrder: false
  };

  node = null;
  subscribeFunction = null;
  burgerNode = null;

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false);
    document.addEventListener("keydown", this.handleEscapeClick, false);
    const storeState = store.default.getState().authReducer;
    if (storeState.access) {
      this.setState({
        access: storeState.access
      });
    }

    this.subscribeFunction = store.default.subscribe(() => {
      const state = store.default.getState().authReducer;

      if (state.userUpdate === FETCH_PERMISSIONS) {
        this.setState({
          access: state.access
        });
      }
    });

    Promise.all([
      crudActions.get('v1/adminpanel/lookups'),
      crudActions.get(`v1/companies/clients`),
      crudActions.get("v1/psp")
    ]).then(
      data => {
        const dropdowns = data[0];
        const companiesData = data[1];
        const providers = data[2];

        if (dropdowns && companiesData && providers) {
          const companies = companiesData.map(elem => elem.company);
          companies.sort((elemA, elemB) => elemA.label.localeCompare(elemB.label));
          this.setState({
            countries: dropdowns.country,
            currencies: dropdowns.currency,
            paymentMethods: dropdowns.buyMethods,
            payoutMethods: dropdowns.payoutMethods,
            companies: companies,
            controls: Object.assign(this.state.controls, {
              companyId: companies[0] ? companies[0].value : ""
            }),
            companiesClients: companiesData.reduce((accumulator, currentElem) => {
              accumulator[currentElem.company.value] = currentElem.clients.map(elem => elem.client);
              return accumulator;
            }, {}),
            companiesMids: companiesData.reduce((accumulator, currentElem) => {
              accumulator[currentElem.company.value] = currentElem.clients.map(elem => elem.mids);
              return accumulator;
            }, {}),
            providers: providers.map(elem => {
              return {
                value: elem.id,
                label: elem.name,
                companyIds: elem.companyIds
              };
            }),
            isLoading: false
          }, () => {
            const { controls } = this.state;
            if (controls.companyId) {
              if (companies[0]) {
                this.onValueChange(companies[0], 'companyId');
              }
            }
          });
        }
      }
    );
  };

  handleClick = (e) => {
    if ((this.node && this.node.contains(e.target)) || (this.burgerNode && this.burgerNode.contains(e.target))) {
      return;
    }

    this.handleClickOutside();
  };

  handleClickOutside = () => {
    if (!this.state.isBurgerOpen) {
      return;
    }
    this.setState({
      isBurgerOpen: false
    });
  };

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false);
    document.removeEventListener("keydown", this.handleEscapeClick, false);
    if (this.subscribeFunction) {
      this.subscribeFunction();
    }
  };

  handleEscapeClick = (event) => {
    if (event.keyCode === 27 && this.state.editableMidId !== "") {
      this.setState({
        editableField: "",
        editableMidId: "",
        editableFieldValue: "",
        originalEditableFieldValue: ""
      });
    }
  };

  onValueChange = (event, field) => {
    let { merchantOptions } = this.state;
    const { controls, companiesClients } = this.state;
    if (!event) {
      controls[field] = event || "";
    } else if (event.target) {
      controls[field] = event.target.value;
    } else if (event.value) {
      controls[field] = event.value;
    } else {
      controls[field] = event.map(elem => elem.value);
    }

    if (field === "companyId") {
      const whiteLabel = controls[field];
      controls.categories = [];
      controls.clientId = "";
      controls.providerId = "";
      merchantOptions = [];
      if (whiteLabel) {
        merchantOptions = merchantOptions.concat(companiesClients[whiteLabel]);
        this.loadCategories(whiteLabel);
      }
    }

    this.setState({
      controls,
      merchantOptions
    });
  };

  loadCategories = (companyId) => {
    crudActions.get(`v1/adminpanel/company/${companyId}`).then(
      (dropdowns) => {
        if (dropdowns) {
          this.setState({
            midCategories: dropdowns.storedLookups.midCategories.map(
              (elem) => {
                return {
                  value: elem,
                  label: elem
                };
              }
            )
          });
        }
      }
    );
  };

  mapSelectedItems = (fieldId, type) => {
    const field = this.state.controls[fieldId];
    const lookup = this.state[type];
    return field.map(elem => {
      return lookup.find(lookupElem => elem === lookupElem.value);
    });
  };
  
  getMidInfo = (midData, infoType) => {
    const midInfo = this.state[infoType].find(elem => elem.value === midData);
    if (!midInfo) {
      return "";
    }

    return midInfo.label;
  };

  checkPageAccess = (permissionName) => {
    const { access } = this.state;
    const foundPermission = access.find(elem => elem.permission === permissionName);
    if (!foundPermission) {
      return false;
    }

    return foundPermission.state;
  };

  tableColumns = () => {
    const columns = [{
      value: "merchants",
      label: "Merchant"
    }, {
      value: "id",
      label: "MID",
      centerAligned: true
    }, {
      value: "midName",
      label: "Tags"
    }, {
      value: "currency",
      label: "Currency"
    }, {
      value: "pspId",
      label: "Providers"
    }, {
      value: "traffic",
      label: "Traffic"
    }, {
      value: "paymentMethod",
      label: "Payin Method"
    }, {
      value: "payoutPaymentMethod",
      label: "Payout Method"
    }, {
      value: "countries",
      label: "Countries"
    }, {
      value: "minDeposit",
      label: "Min Payin",
      isEditable: true
    }, {
      value: "maxDeposit",
      label: "Max Payin",
      isEditable: true
    }, {
      value: "minPayout",
      label: "Min Payout",
      isEditable: true
    }, {
      value: "maxPayout",
      label: "Max Payout",
      isEditable: true
    }, {
      value: "enabled",
      label: "Payin Status",
      centerAligned: true
    }, {
      value: "payoutEnabled",
      label: "Payout Status",
      centerAligned: true
    }, {
      value: "callbackUrl",
      label: "Callback URLs",
      centerAligned: true,
      className: "open-modal-btn",
      buttonLabel: "View",
      isButton: true,
      disableSort: true,
      triggerEvent: (data) => this.onOpenModalClick(data),
      isButtonDisabled: () => { return false; },
      isButtonLoading: () => { return false; }
    }, {
      value: "id",
      label: "View",
      centerAligned: true,
      className: "btn view-mid",
      route: "/view-mid",
      isAction: true,
      disableSort: true
    }];

    if (this.checkPageAccess("MIDS_EDIT")) {
      columns.push({
        value: "id",
        label: "Clone",
        centerAligned: true,
        className: "btn edit-mid clone-mid",
        buttonLabel: "Clone",
        isButton: true,
        disableSort: true,
        triggerEvent: (data) => this.onCloneMidClick(data.id),
        isButtonDisabled: () => { return !!this.state.cloningMidId; },
        isButtonLoading: (data) => { return data.id === this.state.cloningMidId; }
      }, {
        value: "id",
        label: "Edit",
        centerAligned: true,
        className: "btn edit-mid",
        route: "/edit-mid",
        isAction: true,
        disableSort: true
      });
    }

    return columns;
  };

  tableData = () => {
    const { mids, providers, companies, companiesClients } = this.state;

    return mids.map(mid => {
      const foundProvider = providers.find(elem => elem.value === mid.pspId);
      const foundPayoutProvider = mid.payoutPspId ? providers.find(elem => elem.value === mid.payoutPspId) : "";
      const providersLabels = `${foundProvider ? foundProvider.label : ""}${foundPayoutProvider && foundProvider.label !== foundPayoutProvider.label ? ', ' + foundPayoutProvider.label : ""}`;
      const foundCompany = companies.find(elem => elem.value.toString() === mid.companyId.toString());
      const companyMerchants = companiesClients[foundCompany.value] || [];
      const countriesLabel = mid.countries.length === 0 ? "No countries." :
        mid.countries.length === 1 ? this.getMidInfo(mid.countries[0], "countries") : "Multiple Countries";
      const merchants = mid.merchants || [];

      return Object.assign({}, mid, {
        pspId: providersLabels,
        merchants: merchants.length === 0 ?
          "No merchant"
          :
          merchants.length === 1 ?
            companyMerchants.find(merchant => merchant.value.toString() === merchants[0].toString()).label
            :
            "Multi",
        companyId: foundCompany ? foundCompany.label : "",
        paymentMethod: this.getMidInfo(mid.paymentMethod, "paymentMethods"),
        payoutPaymentMethod: mid.payoutPaymentMethod ? this.getMidInfo(mid.payoutPaymentMethod, "payoutMethods") : "",
        countries: countriesLabel,
        currency: this.getMidInfo(mid.currency, "currencies"),
        enabled: mid.enabled ? "On" : "Off",
        payoutEnabled: mid.payoutEnabled ? "On" : "Off"
      });
    });
  };

  onBurgerClick = () => {
    this.setState({
      isBurgerOpen: !this.state.isBurgerOpen
    });
  };

  getFilteredCurrencies = () => {
    const { controls, companiesMids } = this.state;
    if (!controls.companyId) {
      return [];
    }
    const allMids = [];
    companiesMids[controls.companyId].forEach(midsArray => {
      midsArray.forEach(mid => {
        allMids.push(mid);
      });
    });
    const unique = [...new Map(allMids.map(item => [item.currency, item])).values()];
    return unique.map(item => ({ label: item.currency, value: item.currency })).sort((elemA, elemB) => elemA.label.localeCompare(elemB.label));
  };

  getFilteredProviders = () => {
    const { providers, controls } = this.state;
    if (!controls.companyId) {
      return [];
    }
    return providers.filter(provider => provider.companyIds.includes(parseInt(controls.companyId, 10)));
  };

  onDoubleClick = (row, column) => {
    if (column.isEditable && this.checkPageAccess("MIDS_EDIT")) {
      if (((column.value === "minPayout" || column.value === "maxPayout") && row.payoutPspId && row.payoutPaymentMethod) ||
        column.value === "minDeposit" || column.value === "maxDeposit") {
        this.setState({
          editableField: column.value,
          editableMidId: row.id,
          editableFieldValue: row[column.value],
          originalEditableFieldValue: row[column.value]
        });
      }
    }
  };

  onEditableInputChange = (value) => {
    this.setState({
      editableFieldValue: value
    });
  };

  handleEnterPress = (event) => {
    const { editableField, editableFieldValue, originalEditableFieldValue } = this.state;
    if ((event.key === "Enter" && editableFieldValue === originalEditableFieldValue) || event.key === "Escape") {
      this.setState({
        editableField: "",
        editableMidId: "",
        editableFieldValue: "",
        originalEditableFieldValue: ""
      });
      return;
    } else if (event.key === "Enter" && editableFieldValue !== originalEditableFieldValue) {
      this.setState({
        showPromptModal: true,
        changeValueMessage: `Do you want to change the ${editableField}?`
      });
    }
  };

  handleConfirmPromptModal = () => {
    const { editableField, editableFieldValue, editableMidId, mids } = this.state;

    const editableMid = mids.find(mid => mid.id === editableMidId);

    if (editableMid) {
      crudActions.patch(`v1/mids/${editableMidId}`, {
        [editableField]: editableFieldValue
      }).then(() => {
        editableMid[editableField] = editableFieldValue;
        this.props.showAlert(true, "success", `Mid ${editableField} value has been updated!`);
        this.setState({
          mids,
          showPromptModal: false,
          editableField: "",
          editableMidId: "",
          editableFieldValue: "",
          originalEditableFieldValue: ""
        });
      }).catch(
        err => {
          if (err && err.message) {
            this.props.showAlert(true, "error", err.message);
          }
        }
      );
    }
  };

  handleClosePromptModal = () => {
    this.setState({
      showPromptModal: false,
      changeValueMessage: ""
    });
  };

  onOpenModalClick = (data) => {
    this.setState({
      showModal: true,
      modalData: (
        <>
          <div>Payin</div>
          <Well bsSize="small">{ data.callbackUrl }</Well>
          {data.payoutCallbackUrl && (
            <>
              <div>Payout</div>
              <Well bsSize="small">{ data.payoutCallbackUrl }</Well>
            </>
          )}
        </>
      )
    });
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      modalData: ""
    });
  };

  onCloneMidClick = (midId) => {
    if (!midId) return;
    this.setState({
      cloningMidId: midId
    });
    crudActions.get(`v1/mids/${midId}`)
      .then(midData => {
        crudActions.post("v1/mids/clone", midData).then(
          (mid) => {
            window.location.href = `/edit-mid/${mid.id}`;
          }
        ).catch(
          err => {
            if (err && err.message) {
              this.props.showAlert(true, "error", err.message);
              this.setState({
                cloningMidId: null
              });
            }
          }
        );
      })
      .catch(
        err => {
          if (err && err.message) {
            this.props.showAlert(true, "error", err.message);
            this.setState({
              cloningMidId: null
            });
          }
        }
      );
  };

  filterMids = (sortBy, sortDirection) => {
    const { controls, currentPage, pageSize } = this.state;

    const isFormValid = controls.isFormValid();
    this.setState({
      controls,
      ...(sortBy && { defaultSortBy: sortBy }),
      ...(sortDirection && { isDescendingOrder: sortDirection === "DESC" })
    });
    if (isFormValid) {
      const data = Object.assign(controls.data(), {
        pageNumber: currentPage,
        pageSize: pageSize,
        orderBy: sortBy || this.state.defaultSortBy,
        descendingOrder: this.state.isDescendingOrder
      });
      this.setState({
        isLoadingTable: true
      });
      crudActions.post('v1/mids/search', data)
        .then(response => {
          if (response) {
            this.setState({
              mids: response.data,
              count: response.count,
              filterOn: true,
              isLoadingTable: false
            });
          }
        })
        .catch(
          err => {
            if (err && err.message) {
              this.props.showAlert(true, "error", err.message);
              this.setState({
                isLoadingTable: false
              });
            }
          }
        );
    }
  };

  handleChangePage = (event) => {
    const { currentPage } = this.state;
    let pageNum = currentPage;

    if (event.target.getAttribute('data-testid') === "NavigateBeforeIcon"
      || event.target.getAttribute('aria-label') === "Go to previous page") {
      pageNum--;
    } else if (event.target.getAttribute('data-testid') === "NavigateNextIcon"
      || event.target.getAttribute('aria-label') === "Go to next page") {
      pageNum++;
    } else
      if(event.target.textContent){
        pageNum = event.target.textContent;
      }
   
    this.setState({ currentPage: pageNum }, () => {
      this.filterMids();
    }); 
  };

  render() {
    const {
      companies,
      controls,
      count,
      countries,
      currentPage,
      editableField,
      editableFieldValue,
      editableMidId,
      filterOn,
      isBurgerOpen,
      isLoading,
      isLoadingTable,
      merchantOptions,
      midCategories,
      midsLinks,
      modalData,
      pageSize,
      showModal,
      trafficTypes
    } = this.state;

    const columns = this.tableColumns();
    const totalPageCount = Math.ceil(count / pageSize);

    return (
      <Row flexGrow={ 1 } className="module mids" vertical='start'>
        <Column flexGrow={ 1 }>
          <Row className="header" flexGrow={ 1 } horizontal='space-between' vertical='center'>
            <Column>
              <Row horizontal='center' vertical='center' style={ {paddingLeft: 15} }>
                <img src={ MidsIcon } alt="" style={ {marginRight: 10} }/>
                MIDs
              </Row>
            </Column>
            <Column horizontal='end'>
              <Row horizontal='end' vertical='center'>
                { this.checkPageAccess("MIDS_EDIT") && <Column horizontal='end' style={ {paddingRight: 15} }>
                  <Row horizontal='end' vertical='center' style={ {color: '#ccc', fontSize: '12px'} }>
                    <NavLink to={ `/add-mid` } className="btn add-deposit-button">
                      ADD MIDs
                    </NavLink>
                    <div ref={ node => this.burgerNode = node } className={ "burger-container " + (isBurgerOpen ? "change" : "") } style={ { float: "right" } }  onClick={ this.onBurgerClick }>
                      <div className="burger-bar1"></div>
                      <div className="burger-bar2"></div>
                      <div className="burger-bar3"></div>
                    </div>
                    { isBurgerOpen && <div ref={ node => this.node = node } className="burger-content">
                      { midsLinks.map((link, i) => {
                        return <div key={ i } className="link-item-container">
                          <NavLink to={ link.url } className="link-item" onClick={ () => this.handleClickOutside() }> {link.name} </NavLink>
                        </div>;
                      }) }
                    </div>
                    }
                  </Row>
                </Column> }
              </Row>
            </Column>
          </Row>
          <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='start'>
            <Column flexGrow={ 1 } vertical='start' className="panel-block">
              <Panel>
                <Panel.Heading>
                  <Panel.Title>
                    SEARCH MIDs
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  { isLoading ? (
                    <div style={ { width: "100%", height: "400px", display: "flex", alignItems: "center", justifyContent: "center" } }>
                      <Spinner smallContainer={ true } />
                    </div>
                  ) : (
                    <div className="panel-content" style={ {overflow: 'unset'} }>
                      <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' style={ { width: '100%' } }>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <label> White Label </label>
                          <Select
                            id="companyId"
                            name="companyId"
                            value={ controls.companyId }
                            required={ true }
                            clearable={ false }
                            className={ controls.errors.has("companyId") ? "error-field" : "" }
                            onChange={ (value) => this.onValueChange(value, 'companyId') }
                            options={ companies }
                          />
                        </Column>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <label> Merchant </label>
                          <Select
                            id="clientId"
                            name="clientId"
                            value={ controls.clientId }
                            required={ false }
                            clearable={ true }
                            className={ controls.errors.has("clientId") ? "error-field" : "" }
                            onChange={ (value) => this.onValueChange(value, 'clientId') }
                            options={ merchantOptions }
                          />
                        </Column>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <label> Provider </label>
                          <Select
                            id="providerId"
                            name="providerId"
                            value={ controls.providerId }
                            required={ false }
                            clearable={ true }
                            className={ controls.errors.has("providerId") ? "error-field" : "" }
                            onChange={ (value) => this.onValueChange(value, 'providerId') }
                            options={ this.getFilteredProviders() }
                          />
                        </Column>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <label> Currency </label>
                          <Select
                            id="currency"
                            name="currency"
                            value={ controls.currency }
                            required={ false }
                            clearable={ true }
                            className={ controls.errors.has("currency") ? "error-field" : "" }
                            onChange={ (value) => this.onValueChange(value, 'currency') }
                            options={ this.getFilteredCurrencies() }
                          />
                        </Column>
                      </Row>
                      <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' style={ { width: '100%' } }>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <label> Country </label>
                          <Select
                            id="country"
                            name="country"
                            value={ controls.country }
                            required={ false }
                            clearable={ true }
                            className={ controls.errors.has("country") ? "error-field" : "" }
                            onChange={ (value) => this.onValueChange(value, 'country') }
                            options={ countries }
                          />
                        </Column>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <label> Traffic Type </label>
                          <Multiselect
                            selectedItems={ this.mapSelectedItems("trafficTypes", "trafficTypes") }
                            isError={ controls.errors.has('trafficTypes') }
                            disabled={ false }
                            items={ trafficTypes }
                            type="trafficTypes"
                            onChange={ (e) => this.onValueChange(e, "trafficTypes") }/>
                        </Column>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <label> Category </label>
                          <Multiselect
                            selectedItems={ this.mapSelectedItems("categories", "midCategories") }
                            isError={ controls.errors.has('categories') }
                            disabled={ false }
                            items={ midCategories }
                            type="categories"
                            onChange={ (e) => this.onValueChange(e, "categories") }/>
                        </Column>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <label> MID </label>
                          <input
                            className="form-control"
                            value={ controls.midName }
                            onChange={ (event) => this.onValueChange(event, 'midName') }/>
                        </Column>
                      </Row>
                      <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' style={ { width: '100%' } }>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column empty-column">
                          <span/>
                        </Column>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column empty-column">
                          <span/>
                        </Column>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column empty-column">
                          <span/>
                        </Column>
                        <Column flexGrow={ 1 } className="input-column fullwidth-button">
                          <CustomButton
                            title="Search"
                            type="submit"
                            disabled={ isLoadingTable }
                            onClick={ () => this.filterMids() }
                          />
                        </Column>
                      </Row>
                      { filterOn && (
                        <div className="mids-table">
                          <Table
                            columns={ columns }
                            data={ this.tableData() }
                            isStriped={ true }
                            useArrow={ true }
                            useBESort={ true }
                            editableField={ editableField }
                            editableMidId={ editableMidId }
                            editableFieldValue={ editableFieldValue }
                            onKeyDown={ (event) => this.handleEnterPress(event) }
                            onEditableInputChange={ (value) => this.onEditableInputChange(value) }
                            onDoubleClick={ (row, column) => this.onDoubleClick(row, column) }
                            onSortClick={ (sortBy, sortDirection) => this.filterMids(sortBy, sortDirection) }
                          />
                        </div>
                      )}
                    </div>
                  )}
                </Panel.Body>
              </Panel>

              {filterOn && totalPageCount > 0 && (
                <Panel style={ { marginTop : "-13px", borderColor : "white", maxHeight: "105px", minHeight: "100px" } }>
                  <Panel.Body>
                    <div className="pagination">
                      <Pagination 
                        count={ totalPageCount } 
                        variant="outlined" 
                        shape="rounded" 
                        page={ Number(currentPage) }
                        onClick= { this.handleChangePage } 
                      />
                    </div>
                  </Panel.Body>
                </Panel>
              )}

            </Column>
          </Row>
        </Column>

        <Modal
          title="Callback URLs"
          handleClose={ this.handleCloseModal }
          showModal={ showModal }
          modalType="text"
          data={ modalData }
        />

        <PromptModal
          title="Change value"
          message={ this.state.changeValueMessage }
          handleConfirm={ this.handleConfirmPromptModal }
          handleClose={ this.handleClosePromptModal }
          isLoading={ false }
          showModal={ this.state.showPromptModal }
        />

      </Row>
    );
  }
};

function mapStateToProps(state) {
  return {
    alert: state.alert
  };
};

export default connect(mapStateToProps, actions)(Mids);
